import { openBlock as r, createElementBlock as a, normalizeStyle as c, renderSlot as o } from "vue";
import "./watson.WStackItem.es2.js";
import s from "./watson.es37.js";
const l = {
  name: "WStackItem",
  props: {
    /**
     * The flex property sets how a flex item will grow or shrink to fit the space available in its flex container.
     * @values any valid CSS flex value
     * @default '0 1 auto'
     * */
    flex: {
      type: String,
      default: "0 1 auto"
    }
  },
  computed: {
    stackItemStyle() {
      return {
        "--w-stack-item-flex": this.flex
      };
    }
  }
};
function m(t, n, f, p, i, e) {
  return r(), a("div", {
    class: "w-stack-item w-stack-item-flex",
    style: c(e.stackItemStyle)
  }, [
    o(t.$slots, "default")
  ], 4);
}
const S = /* @__PURE__ */ s(l, [["render", m]]);
export {
  S as default
};
